export default __webpack_public_path__ + "static/herolp-825fce44137d9c823204cd3331a0f48e.jpg";